import {
  DialogActions as MuiDialogActions,
  DialogActionsProps as MuiDialogActionsProps,
} from '@mui/material';
import { DialogActionsSx } from './DialogActions.props';

type Props = MuiDialogActionsProps;

function DialogActions(props: Props) {
  return (
    <MuiDialogActions
      {...props}
      disableSpacing
      sx={{ ...DialogActionsSx, ...props.sx }}
    />
  );
}

export default DialogActions;
